var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{tag:"component",attrs:{"page":_vm.page,"settings":_vm.settings}})}
var staticRenderFns = []

export { render, staticRenderFns }